/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class AgentCompatibilityPropertyTypeEnum.
* @enum {}
* @readonly
*/
export default class AgentCompatibilityPropertyTypeEnum {
    
        /**
         * value: "区分"
         * @const
         */
        "区分" = "区分";

    
        /**
         * value: "一棟"
         * @const
         */
        "一棟" = "一棟";

    
        /**
         * value: "戸建"
         * @const
         */
        "戸建" = "戸建";

    
        /**
         * value: "海外"
         * @const
         */
        "海外" = "海外";

    
        /**
         * value: "その他"
         * @const
         */
        "その他" = "その他";

    

    /**
    * Returns a <code>AgentCompatibilityPropertyTypeEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/AgentCompatibilityPropertyTypeEnum} The enum <code>AgentCompatibilityPropertyTypeEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

